import {handleActions} from 'redux-actions';
import {GET_CONTENT_ITEM_VIEW_TITLES} from './ContentItemViewTitlesActions';

export const setContentItemViewTitles = (state: any, action: any) => {
    if (action.error)
        return initialState;

    const {payload} = action;

    const {
        data,
    } = payload;

    return {
        series: data,
    };
};

export const initialState = {
    series: []
};

const handlers = {
    [GET_CONTENT_ITEM_VIEW_TITLES]: setContentItemViewTitles,
};

export default handleActions(handlers, initialState);
